<template>
  <org-detail/>
</template>

<script>
import OrgDetail from '@/components/pages/InformationPortal/Organisation/OrgDetail/OrgDetail.vue'
import organisationRolesMixin from '@/mixins/organisationPermissionsMixin'

export default {
    name: 'Organisation',
    mixins: [organisationRolesMixin],
    components:{
        OrgDetail
    },
    created () {
      this.setOrganisationRoleAndPermissions()
    },
    beforeDestroy () {
      // clear the permissions store on destroy
      this.$store.dispatch('clearPermissionsAndRoles')
    }
}
</script>